import { FC } from "react";
import { CustomCellRendererProps } from "ag-grid-react";
import Stack from "@mui/material/Stack";
import { TypographyWithTooltip } from "../../../../common/TypographyWithTooltip";
import { CopyIconButton } from "../../../../common/CopyIconButton";
import { opportunityTypeTitlesByActionType } from "../../utils/constants/common";
import { autoGroupColumnId } from "../../../task-management/components/grid/auto-group-column/getAutoGroupColumnDef";
import { useHover } from "@/utils/hooks/useHover.hook";
import { SavingsOpportunity } from "@/services/cloudchipr.api";

export const SavingsOpportunityActionTypeCellRenderer: FC<
  CustomCellRendererProps<SavingsOpportunity>
> = (cell) => {
  const { ref, hovered } = useHover();

  const colId = cell.column?.getColId() || cell.colDef?.colId;
  const inGroup = colId === autoGroupColumnId;

  const data = cell.data;
  const title = data?.action_type
    ? opportunityTypeTitlesByActionType[data.action_type]
    : "";

  if (!data) {
    return null;
  }

  if (inGroup) {
    return <TypographyWithTooltip title={title} variant="body2" />;
  }

  return (
    <Stack direction="row" spacing={0.5} alignItems="center" ref={ref}>
      <TypographyWithTooltip title={title} variant="body2" />

      <CopyIconButton
        data-block-row-click
        data={title}
        visible={hovered}
        TooltipProps={{ placement: "top" }}
      />
    </Stack>
  );
};
